import { campaignTicketLabel } from "./campaign-ticket-label";

/**
 * Which of the ticket list's optional columns any ticket on the page fills.
 * A column every ticket leaves blank is dropped for the whole page — never
 * per row, so the columns stay aligned — giving its width back to the title,
 * which the fixed-width columns otherwise squeeze off a laptop-width screen.
 */
export interface TicketListColumns {
  /** "Away, no cover" / "Covered by …" */
  cover: boolean;
  category: boolean;
  campaign: boolean;
  /** Customer name and contact email. */
  contact: boolean;
}

export interface TicketListColumnsInput {
  subject_type?: string | null;
  subject_label?: string | null;
  assignee_absent_today?: boolean | null;
  covering_user_name?: string | null;
  category_name?: string | null;
  customer_name?: string | null;
  primary_contact_email?: string | null;
}

export function ticketListColumns(
  tickets: readonly TicketListColumnsInput[],
): TicketListColumns {
  return {
    cover: tickets.some(
      (t) => Boolean(t.assignee_absent_today) || Boolean(t.covering_user_name),
    ),
    category: tickets.some((t) => Boolean(t.category_name)),
    campaign: tickets.some((t) => campaignTicketLabel(t) !== null),
    contact: tickets.some(
      (t) => Boolean(t.customer_name) || Boolean(t.primary_contact_email),
    ),
  };
}
